import { render, staticRenderFns } from "./CandidateDetailsCard.vue?vue&type=template&id=0270b404&scoped=true&"
import script from "./CandidateDetailsCard.vue?vue&type=script&lang=ts&"
export * from "./CandidateDetailsCard.vue?vue&type=script&lang=ts&"
import style0 from "./CandidateDetailsCard.vue?vue&type=style&index=0&id=0270b404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0270b404",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VDivider,VIcon,VImg})
